<template>
  <AppHeader />


  <main class="main-section">
    <router-view /> <!-- To ładuje widoki zależne od trasy -->
  </main>

  <AppFooter />
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: "App",
  components: {
    AppHeader,

    AppFooter
  }
}
</script>
